import React, { forwardRef } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default function ReportsFilterPill({ label, active, options, onSelect, onClear }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-2 bg-background rounded-full h-9 px-4 text-sm font-medium text-dark-blue whitespace-nowrap"
          >
            {active?.label ?? label}

            {
              active
                ? (
                  <UIcons.UilTimes
                    size={14}
                    className="text-secondary"
                    onClick={(event) => { event.stopPropagation(); onClear() }}
                  />
                )
                : (open ? <UIcons.UilAngleUp size={16} className="text-secondary" /> : <UIcons.UilAngleDown size={16} className="text-secondary" />)
            }
          </button>

          {
            open && (
              <div className="absolute right-0 top-11 z-20 w-56 bg-white border border-border-lines rounded-xl shadow-lg py-1">
                {
                  options.map((option, index) => (
                    <button
                      key={option.value ?? 'all'}
                      type="button"
                      onClick={() => { onSelect(option); handleClick() }}
                      className={`w-full flex items-center justify-between gap-2 text-left px-4 py-2.5 text-sm text-dark-blue hover:bg-background ${index < options.length - 1 ? 'border-b border-border-lines' : ''}`}
                    >
                      {option.label}
                      {(active ? active.value === option.value : !option.value) && <UIcons.UilCheck size={16} className="text-primary" />}
                    </button>
                  ))
                }
              </div>
            )
          }
        </div>
      ))}
    />
  )
}
